import { useEffect, useState, useRef } from 'react';
import styles from './cssModules/index.module.css';
import { useNavigate } from 'react-router-dom';

export default function Information({ loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    const navigate = useNavigate();

    const [profile, setProfile] = useState({});

    const [isdisabled, setIsDisabled] = useState(true);

    let jToken = localStorage.getItem('token');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiURL}/home`, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    credentials: 'include'
                })
                if (response.status === 500) {
                    throw new Error('Error while fetching information of seller');
                } else {
                    if (response.status === 200) {
                        const res = await response.json();
                        setProfile({
                            fname: res.fname,
                            lname: res.lname,
                            sname: res.store,
                            address: res.address,
                            pin: res.pin,
                            Baddress: res.bAddress,
                            bPin: res.bAddressPin,
                            bAcc: res.bankAccNo,
                            bAholder: res.holder,
                            gstin: res.gstin,
                            ifsc: res.ifsc,
                            profileImage: res.profileImage || null
                        })
                    } else {
                        await loginStatus();
                        navigate('/login');
                    }
                }
            } catch (error) {
                // Sign out first
                // await loginStatus();
                navigate('/error');
                console.log(error.message);
            }
        }
        fetchData();
    }, [jToken, loginStatus, apiURL, navigate])

    const fileInputRef = useRef(null);

    async function handleImageUpload(e) {
        const file = e.target.files[0];
        if (!file) return;
        if (file.size > 500 * 1024) {
            alert('File size must be less than 500 KB');
            return;
        }
        const formData = new FormData();
        formData.append('image', file);
        try {
            const response = await fetch(`${apiURL}/api/profile/image`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${jToken}` },
                body: formData,
                credentials: 'include'
            });
            console.log('Called')
            if (response.status === 200) {
                const data = await response.json();
                setProfile(prev => ({ ...prev, profileImage: data.profileImage }));
            } else {
                alert('Failed to upload profile picture');
            }
        } catch (error) {
            console.log(error.message);
            navigate('/error');
        }
    }

    async function handleImageRemove(e) {
        e.preventDefault();
        try {
            const response = await fetch(`${apiURL}/api/profile/image/delete`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${jToken}` },
                credentials: 'include'
            });
            if (response.status === 200) {
                setProfile(prev => ({ ...prev, profileImage: null }));
            } else {
                alert('Failed to remove profile picture');
            }
        } catch (error) {
            console.log(error.message);
            navigate('/error');
        }
    }

    function updateProfile(e) {
        e.preventDefault();
        const { name, value } = e.target;
        setProfile((prev) => {
            return ({
                ...prev, [name]: value
            })
        })
    }

    function handleUpdate(e) {
        e.preventDefault();
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiURL}/api/home`, {
                    method: 'POST',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    body: JSON.stringify(profile),
                    credentials: 'include'
                })
                if (response.status === 500) {
                    throw new Error('Error while updating seller information');
                } else {
                    if (response.status === 200) {
                        alert('Profile has been updated successfully!');
                    } else {
                        await loginStatus();
                        navigate('/login');
                    }
                }
            } catch (error) {
                // await loginStatus();
                navigate('/error');
                console.log(error.message);
            }
        }
        fetchData()
    }


    return (
        <>
            <div className={`${styles.sellerInformationDiv}`}>
                <span style={{ fontSize: '20px', fontWeight: '700', letterSpacing: '1px' }}>Personal information</span>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '20px 0', gap: '12px' }}>
                    <div style={{ width: '100px', height: '100px', borderRadius: '50%', overflow: 'hidden', border: '2px solid var(--brand-primary)', background: 'var(--bg-card-alt)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {profile.profileImage
                            ? <img src={`${process.env.REACT_APP_S3_URL}/${profile.profileImage}`} alt='Profile' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            : <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5' style={{ width: '52px', height: '52px', color: 'var(--text-muted)' }}>
                                <path strokeLinecap='round' strokeLinejoin='round' d='M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z' />
                              </svg>
                        }
                    </div>
                    <input type='file' accept='image/jpeg,image/png,image/jpg' ref={fileInputRef} style={{ display: 'none' }} onChange={handleImageUpload} />
                    <div style={{ display: 'flex', gap: '8px' }}>
                        {!profile.profileImage
                            ? <button className={`${styles.sellerInfoButton}`} onClick={(e) => { e.preventDefault(); fileInputRef.current.click(); }}>UPLOAD PHOTO</button>
                            : <>
                                <button className={`${styles.sellerInfoButton}`} onClick={(e) => { e.preventDefault(); fileInputRef.current.click(); }}>CHANGE PHOTO</button>
                                <button className={`${styles.sellerInfoButton}`} onClick={handleImageRemove}>REMOVE PHOTO</button>
                              </>
                        }
                    </div>
                </div>
                <form>
                    <div className={`${styles.formDivSeller}`}>
                        <div className={`${styles.Sellerfname} ${styles.SellerInfoForm}`}>
                            <label for='fname'>
                                {`First name`.toUpperCase()}
                            </label>
                            <input className={`${styles.sellerFormInput}`} type="text" id='fname' name='fname' disabled={isdisabled} placeholder="First name" onBlur={updateProfile} defaultValue={profile.fname} />
                        </div>
                        <div className={`${styles.Sellerlname} ${styles.SellerInfoForm}`}>
                            <label for='lname'>
                                {`Last name`.toUpperCase()}
                            </label>
                            <input className={`${styles.sellerFormInput}`} type="text" name='lname' disabled={isdisabled} placeholder="Last name" onBlur={updateProfile} defaultValue={profile.lname} />
                        </div>
                        <div className={`${styles.Sellerstore} ${styles.SellerInfoForm}`}>
                            <label for='store'>
                                {`Store name`.toUpperCase()}
                            </label>
                            <input className={`${styles.sellerFormInput}`} type="text" id='store' name='sname' disabled={isdisabled} placeholder="Store name" onBlur={updateProfile} defaultValue={profile.sname} />
                        </div>
                        <div className={`${styles.Selleraddress} ${styles.SellerInfoForm}`}>
                            <label for='address'>
                                {`Home address`.toUpperCase()}
                            </label>
                            <input className={`${styles.sellerFormInput}`} type="text" id='address' name='address' disabled={isdisabled} placeholder="Home address" onBlur={updateProfile} defaultValue={profile.address} />
                        </div>
                        <div className={`${styles.SellerApin} ${styles.SellerInfoForm}`}>
                            <label for='pin'>
                                {`Home pin code`.toUpperCase()}
                            </label>
                            <input className={`${styles.sellerFormInput}`} type="text" id='pin' name='pin' disabled={isdisabled} placeholder="Home address Pin code" onBlur={updateProfile} defaultValue={profile.pin} />
                        </div>
                        <div className={`${styles.SellerBAddress} ${styles.SellerInfoForm}`}>
                            <label for='bAddress'>
                                {`Business address`.toUpperCase()}
                            </label>
                            <input className={`${styles.sellerFormInput}`} type="text" id='bAddress' name='Baddress' disabled={isdisabled} placeholder="Business address" onBlur={updateProfile} defaultValue={profile.Baddress} />
                        </div>
                        <div className={`${styles.SellerbPin} ${styles.SellerInfoForm}`}>
                            <label for='bPin'>
                                {`Business address pin code`.toUpperCase()}
                            </label>
                            <input className={`${styles.sellerFormInput}`} type="text" id='bpin' name='bPin' disabled={isdisabled} placeholder="Business address pin code" onBlur={updateProfile} defaultValue={profile.bPin} />
                        </div>
                        <div className={`${styles.Sellergstin} ${styles.SellerInfoForm}`}>
                            <label for='gstin'>
                                {`GSTIN No`.toUpperCase()}
                            </label>
                            <input className={`${styles.sellerFormInput}`} type="text" id='gstin' name='gstin' disabled={true} placeholder="GSTIN no" onBlur={updateProfile} defaultValue={profile.gstin} />
                        </div>
                        <div className={`${styles.SellerBAcc} ${styles.SellerInfoForm}`}>
                            <label for='bAcc'>
                                {`Bank account number`.toUpperCase()}
                            </label>
                            <input className={`${styles.sellerFormInput}`} type="text" id='bAcc' name='bAcc' disabled={true} placeholder="Bank account number" onBlur={updateProfile} defaultValue={profile.bAcc} />
                        </div>
                        <div className={`${styles.SellerHolder} ${styles.SellerInfoForm}`}>
                            <label for='bAholder'>
                                {`Bank account holder name`.toUpperCase()}
                            </label>
                            <input className={`${styles.sellerFormInput}`} type="text" id='bAholder' name='bAholder' disabled={true} placeholder="Account holder name" onBlur={updateProfile} defaultValue={profile.bAholder} />
                        </div>
                        <div className={`${styles.Sellerifsc} ${styles.SellerInfoForm}`}>
                            <label for='ifsc'>
                                {`ifsc code`.toUpperCase()}
                            </label>
                            <input className={`${styles.sellerFormInput}`} type="text" id='ifsc' name='ifsc' disabled={true} placeholder="IFSC" onBlur={updateProfile} defaultValue={profile.ifsc} />
                        </div>
                    </div>
                </form>
                <div className={`${styles.sellerInfoButtonDiv}`}>
                    <button className={`${styles.sellerInfoButton}`} onClick={(e) => { e.preventDefault(); setIsDisabled(!isdisabled) }}>
                        EDIT
                    </button>
                    <button className={`${styles.sellerInfoButton}`} onClick={(e) => handleUpdate(e)}>
                        SAVE
                    </button>
                    <button className={`${styles.sellerInfoButton}`} onClick={async () => { await loginStatus(); }}>
                        LOG OUT
                    </button>
                </div>
            </div>
        </>
    )
}